<ng-container *ngIf="user$ | async as user; else login">
  <div class="user-data">
    <button
      class="my-company-button"
      *ngIf="isAdmin$() | async"
    >
      <img
        src="/images/my-company-icon.svg"
        alt="Icon of a company or store, on blue color"
      />
      <div
        (mouseenter)="changeCompanySubMenu()"
        (mouseleave)="hideCompanySubMenu()"
      >
        <cx-icon
          [cxIcon]="ICON_TYPE.CARET_DOWN"
          (click)="changeCompanySubMenu()"
        />
        <div class="my-company-popup" *ngIf="isCompanySubMenuOpen">
          <div class="wrapper">
            <a
              class="cx-link"
              [routerLink]="'/organization/users'"
            >{{ 'gonvarri.header.company.users' | cxTranslate }}</a>
            <a
              class="cx-link"
              [routerLink]="'/my-company/organization-management/address-book'"
            >{{ 'gonvarri.header.company.addresses' | cxTranslate }}</a>
          </div>
        </div>
        <div class="holder" *ngIf="isCompanySubMenuOpen"></div>
      </div>
    </button>
    <button
      [class]="'my-account-button'"
    >
      <div class="image-holder" (click)="changeAccountSubMenu()">
        <img
          src="/images/my-account-icon.svg"
          alt="Icon of a person, on blue color"
        />
      </div>
      <div (click)="changeAccountSubMenu()" [class]="(isAccountSubMenuOpen || firstClick) ? '' : 'hidden'">
        <cx-page-slot id="account-nav" position="HeaderLinks"></cx-page-slot>
      </div>
    </button>
  </div>
</ng-container>

<ng-template #login>
  <a role="link" [routerLink]="{ cxRoute: 'login' } | cxUrl">{{
      'miniLogin.signInRegister' | cxTranslate
    }}</a>
</ng-template>
